import { createSlice } from "@reduxjs/toolkit";

const supportReducerSlice = createSlice({
  name: "support",
  initialState: {
    support: null,
    error: false,
    errorMessage: "",
  },
  reducers: {
    getReportTransactionSuccess: (state, action) => {
      state.transactionDetails = action.payload;
    },
    getSessionSuccess: (state, action) => {
      state.sessionDetails = action.payload;
    },
    getAgentSuccess: (state, action) => {
      state.agentDetails = action.payload;
    },
    getUserSuccess: (state, action) => {
      state.userDetails = action.payload;
    },
    getReportSuccess: (state, action) => {
      state.reportDetails = action.payload;
    },
  },
  selectors: {
    getReportTransactionData: (state) => state.transactionDetails ?? {},
    getSessionData: (state) => state.sessionDetails ?? {},
    getAgentData: (state) => state.agentDetails ?? {},
    getUserData: (state) => state.userDetails ?? {},
    getReportData: (state) => state.reportDetails ?? {},
  }
});

export const {
  getReportTransactionSuccess, getSessionSuccess, getAgentSuccess, getUserSuccess, getReportSuccess
} = supportReducerSlice.actions;

export const { getReportTransactionData, getSessionData, getAgentData, getUserData, getReportData } =
supportReducerSlice.selectors;

export default supportReducerSlice.reducer;
